import { GridCol, GridContainer, GridRow } from '@bob/library'
import { mapTableOfContent } from '@websrc/DataMappers/mapSpot'
import React from 'react'

import * as SC from './SpotTableOfContent.style'

export interface SpotTableOfContentProps {
  spot: ReturnType<typeof mapTableOfContent>['table_of_content']
}

export function SpotTableOfContent({ spot }: SpotTableOfContentProps) {
  if (spot.settings.dual_column) {
    return (
      <GridContainer>
        <GridRow>
          {spot.sections.map(({ headline, links }, sectionI) => {
            return (
              <SC.ColWithMargin key={sectionI} tablet={6}>
                <SC.Headline>{headline}</SC.Headline>
                {links.map((link, linkI) => (
                  <SC.StyledLink ctaType={'tertiary'} key={linkI} link={link}>
                    {link.cta_text}
                  </SC.StyledLink>
                ))}
              </SC.ColWithMargin>
            )
          })}
        </GridRow>
      </GridContainer>
    )
  }

  return (
    <GridContainer>
      {spot.sections.map(({ headline, links }, sectionI) => {
        return (
          <SC.RowWithMargin key={sectionI}>
            <GridCol>
              <SC.Headline>{headline}</SC.Headline>
            </GridCol>
            {links.map((link, linkI) => (
              <GridCol key={linkI} tablet={6}>
                <SC.StyledLink ctaType={'tertiary'} link={link}>
                  {link.cta_text}
                </SC.StyledLink>
              </GridCol>
            ))}
          </SC.RowWithMargin>
        )
      })}
    </GridContainer>
  )
}
